@for (customField of customFields; track customField) {
  <div class="attribute-card" [ngClass]="{ 'show-empty': showEmpty }">
    <div class="editor" [ngClass]="{ 'is-empty': isEmpty(customField) }">
      <profile-custom-field-editor
        [customFieldValues]="getCustomFieldValueByTypeId(customField.id)"
        [customField]="customField"
        [id]="customField.id"
        [genericAttributeService]="
          buildGenericPersonAttributeService(customField)
        "
      ></profile-custom-field-editor>
    </div>
    @if (!isEmpty(customField) || showEmpty) {
      <mat-divider></mat-divider>
    }
  </div>
}
